module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("Cover Design: "), _c('a', {
    attrs: {
      "href": "http://www.written-ink.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Written Ink Designs")])]), _vm._v(" | written-ink.com")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Image(s) used under a Standard Royalty-Free License.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work and violators will be prosecuted to the fullest extent of the law.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("No portion of this book may be transmitted or reproduced in any form, or by any means, without permission in writing from the publisher, with the exception of brief excerpts used for the purposes of review.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("This is a work of fiction. Names, characters, places and incidents are solely the product of the author’s imagination and/or are used fictitiously, though reference may be made to actual historical events or existing locations. Any resemblance to actual persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Published in the United States of America. Queerteen Press is an imprint of JMS Books LLC. This story was first published in 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Kim would like to thank J.M Snyder and the QTP editors, Liz Penn, Jay Willis, Dennis Smith/Gothic Blues, Camp NaNo, The Wild Bookstore, "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("The Polk Street Review")]), _vm._v(", "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("MOOT")]), _vm._v(" "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Magazine")]), _vm._v(", "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Windy City Times")]), _vm._v(", and Malissa and James Flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df9472c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0